
export default class ContentLoader {
    constructor() { }

    _setEvents(xhr, success, fail) {
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status >= 200 && xhr.status < 400) {
                    if (success) {
                        let url = null;

                        if (xhr.responseURL !== undefined) {
                            url = xhr.responseURL;
                        }

                        success(xhr.responseText, url, xhr);
                    }
                }
                else {
                    if (fail) {
                        fail(xhr);
                    }
                }
            }
        };

    }


    _xhr() {
        return new XMLHttpRequest();
    }



    newRequest(href, config, successCallback, failCallback, postdata, contenttype) {

        const req = this._xhr();
        let method = (postdata) ? 'POST' : 'GET';

        req.open(method, href);

        var ctype = ((typeof contenttype !== "undefined") ? contenttype : 'application/x-www-form-urlencoded');

        if (postdata) {
            req.setRequestHeader("Accept", ctype)
            req.setRequestHeader('Content-type', ctype);
        }

        req.setRequestHeader("X-Requested-With", "XMLHttpRequest");


        let _success = typeof successCallback == 'function' ? successCallback : () => console.log('content loaded');
        let _fail = typeof failCallback == 'function' ? failCallback : () => console.log('content loading failed');


        let successAjax = (response, url, xhr) => {
            if (config.destination && response) {
                let sourceContent = response.trim();

                if (config.append) {
                    let _div = document.createElement('div');
                    _div.innerHTML = sourceContent;
                    config.destination.appendChild(_div);
                }
                else {
                    config.destination.innerHTML = sourceContent;
                    // reset scroll position after HTML is replaced
                    if (config.destination.parentNode){
                        config.destination.parentNode.scrollTop = 0;
                    }
                }

                _success.call(this, response, url, xhr);
            }
            else {
                _success.call(this, response, url, xhr);
            }
        }

        this._setEvents(req, successAjax, _fail);


        if (postdata) {
            req.send(postdata);
        }
        else {
            req.send();
        }
    }
}
